"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_visually_hidden_1 = require("@hopin-team/ui-visually-hidden");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importDefault(require("react"));

var root_1 = require("./styled/root");

var Spinner = function Spinner(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      className = _a.className,
      isAssertive = _a.isAssertive,
      isPolite = _a.isPolite,
      isShowing = _a.isShowing,
      _b = _a.label,
      label = _b === void 0 ? 'Loading…' : _b,
      _c = _a.pattern,
      pattern = _c === void 0 ? 'primary' : _c,
      _d = _a.size,
      size = _d === void 0 ? 'medium' : _d,
      _m = _a.m,
      _mb = _a.mb,
      _ml = _a.ml,
      _mr = _a.mr,
      _mt = _a.mt,
      _mx = _a.mx,
      _my = _a.my,
      _p = _a.p,
      _pb = _a.pb,
      _pl = _a.pl,
      _pr = _a.pr,
      _pt = _a.pt,
      _px = _a.px,
      _py = _a.py,
      props = tslib_1.__rest(_a, ["__UIScope", 'data-testid', "className", "isAssertive", "isPolite", "isShowing", "label", "pattern", "size", "m", "mb", "ml", "mr", "mt", "mx", "my", "p", "pb", "pl", "pr", "pt", "px", "py"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: Spinner.name,
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var labelledById = (0, use_id_1.useId)();
  var a11yProps = {};

  if (isAssertive) {
    a11yProps.role = 'alert';
    a11yProps['aria-live'] = 'assertive';
  }

  if (isPolite) {
    a11yProps.role = 'status';
    a11yProps['aria-live'] = 'polite';
  }

  return react_1.default.createElement("div", tslib_1.__assign({
    "data-testid": testID,
    "aria-atomic": true,
    "aria-labelledby": labelledById
  }, a11yProps, props), isShowing && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ui_visually_hidden_1.VisuallyHidden, {
    as: "label",
    id: labelledById
  }, label), react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    pattern: pattern,
    size: size
  })));
};

var SpinnerWithSpace = (0, ui_helper_with_space_1.withSpace)(Spinner);
exports.Spinner = SpinnerWithSpace;